import { Tv } from '@mui/icons-material';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { applyServerErrors } from '~/api/helpers';
import { useCreateTVBrand } from '~/api/tv-brands/create';
import { RouterBreadcrumbs } from '~/components/RouterBreadcrumbs';
import { SaveButton } from '~/components/button';
import { PageContainer } from '~/components/page-layout';
import { Toolbar } from '~/components/toolbar';
import { useAppContext } from '~/contexts';
import { useLink } from '~/hooks/link';
import { TVBrandForm, getValidationSchema } from './detail/components';

export const NewTVBrand = () => {
  const { t } = useTranslation();
  const { currentNetwork } = useAppContext();

  const navigate = useNavigate();

  const link = useLink();

  const [createTVBrand] = useCreateTVBrand();

  const validationSchema = getValidationSchema(t);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      baudRate: '',
      mute: '',
      name: '',
      powerOff: '',
      powerOn: '',
      unmute: '',
      volumeDown: '',
      volumeUp: '',
    },
    onSubmit: async (values, { setErrors }) => {
      const newValues = validationSchema.cast(values);
      const result = await createTVBrand({
        variables: {
          input: {
            ...newValues,
            baudRate: Number(newValues.baudRate),
            networkId: currentNetwork.id,
          },
        },
      });
      applyServerErrors(result, setErrors);
      if (result.errors) return;
      navigate(link(`/tv-brands/${result.data?.createTvBrand?.tvBrand.id}`));
    },
    validateOnMount: true,
    validationSchema,
  });

  return (
    <>
      <Toolbar
        actions={
          <SaveButton
            disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
            type="submit"
            form="tv-brand-form"
          />
        }
        breadcrumbsLabel={<RouterBreadcrumbs />}
        titleIcon={<Tv />}
        titleText={t('pages.tv_brands.title')}
      />

      <PageContainer>
        <TVBrandForm formik={formik} formId="tv-brand-form" />
      </PageContainer>
    </>
  );
};
